var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchField = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 30,
  x: 1,
  y: 1,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon)",
  fillRule: "evenodd",
  d: "M13.498 14.923a3.421 3.421 0 1 1 6.843 0 3.421 3.421 0 0 1-6.843 0m3.421-4.921a4.921 4.921 0 1 0 2.91 8.89l2.817 2.818a.75.75 0 0 0 1.06-1.06l-2.817-2.818a4.921 4.921 0 0 0-3.97-7.83",
  clipRule: "evenodd"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 108,
  height: 4,
  x: 36.734,
  y: 14,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})));
export default SvgSearchField;